import { Page } from "@/components/Page";
import { PageHero } from "@/components/PageHero";
import { ServiceList } from "@/components/ServiceList";
import { HomeVisit } from "@/components/home/HomeVisit";
import { WhyChoose } from "@/components/WhyChoose";
import { AppointmentSection } from "@/components/AppointmentSection";
import { PHYSIO_SERVICES, STOCK } from "@/data/site";

export default function Physiotherapy() {
  return (
    <Page>
      <PageHero
        crumb="Physiotherapy"
        overline="Physiotherapy & Rehabilitation"
        title={"Physiotherapy &\nRehabilitation"}
        subtitle="Personalized care to reduce pain, restore movement and help you return to everyday activities."
        image={STOCK.heroPhysio}
      />
      <ServiceList
        overline="Our Services"
        title="Comprehensive Physiotherapy Care"
        subtitle="From pain management to advanced rehabilitation, our physiotherapy services are tailored to your recovery — with no medical guarantees, only responsible, personalized care."
        services={PHYSIO_SERVICES}
        ctaLabel="Book a Physiotherapy Appointment"
        accent="teal"
      />
      <HomeVisit />
      <WhyChoose />
      <AppointmentSection />
    </Page>
  );
}
